export default {
  contact: state => state.contact,
  contacts: state => state.contacts,
  contactsFound: state => state.contactsFound,
  addressesFound: state => state.addressesFound,
  phonesFound: state => state.phonesFound,
  birthdaysFound: state => state.birthdaysFound,
  contactAddresses: state => state.contactAddresses,
  contactPhones: state => state.contactPhones,
  contactEmails: state => state.contactEmails,
  address: state => state.address,
  status: state => state.status,
  pageSize: state => state.pageSize,
  searchTerm: state => state.searchTerm,
  retrospectiveDay: state => state.retrospectiveDay,
  filterOptions: state => state.filterOptions,
  filterBy: state => state.filterBy,
  sortDir: state => state.sortDir,
  orderBy: state => state.orderBy,
  isContactChecked: state => state.isContactChecked,
  income: state => state.income,
  isIncomeChecked: state => state.isIncomeChecked,
  expenses: state => state.expenses,
  isExpenseChecked: state => state.isExpenseChecked,
  related: state => state.related,
  isVendors: state => state.isVendors,
  isVendorChecked: state => state.isVendorChecked
}



// WEBPACK FOOTER //
// ./src/store/modules/contacts/getters.js